var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo } from "react";
import PaginationV2 from "./PaginationV2";
import PaginationLink from "./PaginationLink";
import { calculatePagesToDisplay } from "./Pagination.utils";
var PaginationControl = forwardRef(function (_a, ref) {
    var currentPage = _a.currentPage, totalPage = _a.totalPage, onChangePage = _a.onChangePage, hasSideMenu = _a.hasSideMenu, className = _a.className, style = _a.style, otherProps = __rest(_a, ["currentPage", "totalPage", "onChangePage", "hasSideMenu", "className", "style"]);
    if (currentPage < 1) {
        throw new Error("The current page cannot be less than 1.");
    }
    if (currentPage > totalPage) {
        throw new Error("The current page cannot be more than total pages.");
    }
    var onChange = function (pageNumber, event) {
        event.preventDefault();
        event.stopPropagation();
        if (onChangePage) {
            onChangePage(pageNumber, event);
        }
    };
    var displayPrevNextLabelAfter = useMemo(function () {
        return hasSideMenu ? "xl" : "lg";
    }, [hasSideMenu]);
    var firstPage = useMemo(function () {
        if (currentPage === 1) {
            return (React.createElement(PaginationLink, { type: "first", "aria-disabled": true, key: "first" }, "Premi\u00E8re page"));
        }
        return (React.createElement(PaginationLink, { type: "first", href: "#", onClick: function (e) { return onChange(1, e); }, key: "first" }, "Premi\u00E8re page"));
    }, [currentPage]);
    var previousPage = useMemo(function () {
        if (currentPage === 1) {
            return (React.createElement(PaginationLink, { type: "prev", displayLabelAfter: displayPrevNextLabelAfter, "aria-disabled": true, key: "prev" }, "Page pr\u00E9c\u00E9dente"));
        }
        return (React.createElement(PaginationLink, { type: "prev", href: "#", displayLabelAfter: displayPrevNextLabelAfter, onClick: function (e) { return onChange(currentPage - 1, e); }, key: "prev" }, "Page pr\u00E9c\u00E9dente"));
    }, [currentPage, hasSideMenu]);
    var nextPage = useMemo(function () {
        if (currentPage >= totalPage) {
            return (React.createElement(PaginationLink, { type: "next", displayLabelAfter: displayPrevNextLabelAfter, "aria-disabled": true, key: "next" }, "Page suivante"));
        }
        return (React.createElement(PaginationLink, { type: "next", href: "#", displayLabelAfter: displayPrevNextLabelAfter, onClick: function (e) { return onChange(currentPage + 1, e); }, key: "next" }, "Page suivante"));
    }, [currentPage, totalPage, hasSideMenu]);
    var lastPage = useMemo(function () {
        if (currentPage >= totalPage) {
            return (React.createElement(PaginationLink, { type: "last", "aria-disabled": true }, "Derni\u00E8re page"));
        }
        return (React.createElement(PaginationLink, { type: "last", href: "#", onClick: function (e) { return onChange(totalPage, e); } }, "Derni\u00E8re page"));
    }, [currentPage, totalPage]);
    function renderPaginationLink(pageNumber, displayAfter) {
        if (displayAfter === void 0) { displayAfter = undefined; }
        if (pageNumber === currentPage) {
            return (React.createElement(PaginationLink, { "aria-current": "page", displayAfter: displayAfter, onClick: function (e) { return onChange(pageNumber, e); }, key: pageNumber }, pageNumber));
        }
        return (React.createElement(PaginationLink, { href: "#", displayAfter: displayAfter, onClick: function (e) { return onChange(pageNumber, e); }, key: pageNumber }, pageNumber));
    }
    function renderPaginationLinkEllipsis(displayAfter, index) {
        return React.createElement(PaginationLink, { displayAfter: displayAfter, key: "ellipsis-".concat(index) }, "...");
    }
    var pagesDisplayed = useMemo(function () {
        var pagesToDisplay = calculatePagesToDisplay(currentPage, totalPage);
        return (React.createElement(React.Fragment, null, pagesToDisplay.map(function (pageToDisplay, index) {
            if (pageToDisplay.ellipsis || !pageToDisplay.page) {
                return renderPaginationLinkEllipsis(pageToDisplay.displayAfter, index);
            }
            return renderPaginationLink(pageToDisplay.page, pageToDisplay.displayAfter);
        })));
    }, [currentPage, totalPage]);
    return (React.createElement(PaginationV2, __assign({}, otherProps, { ref: ref, className: className ? className : "", style: style }),
        firstPage,
        previousPage,
        pagesDisplayed,
        nextPage,
        lastPage));
});
export default PaginationControl;
